import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledHeader } from './components/header/header-style';
import { ToggleSwitch, Tabs } from '@oneaudi/unified-web-alpha-components';
import { useI18n } from './i18n/i18n';
import { useCarlineStore } from './store/carline';
import { StandardEquipment } from './components/standard-equipment/standard-equipment';
import { TechData } from './components/tech-data/tech-data';
import { useEffect } from 'react';
import { useModelTechnicalDataSection } from './hooks/use-technical-data-sections';
import { EventAction } from './types/tracking';
import { useTracking } from './hooks/use-tracking';
export const App = ({ actions }) => {
    var _a, _b;
    const { compare, configuredCar, setCompare, appConfig: config, selectedEngine, secondSelectedEngine, } = useCarlineStore();
    const { handleTrackEvent, handleUpdateComponentInfo, baseTrackingEventName } = useTracking();
    const techData = useModelTechnicalDataSection(selectedEngine === null || selectedEngine === void 0 ? void 0 : selectedEngine.technicalDataV2);
    const { i18n } = useI18n();
    const tabIndexToTabName = ['standardEquipment', 'technicalData'];
    const handleTabTrackEvent = (tabName) => {
        const eventName = `configurator - ${tabName} layer`;
        handleTrackEvent({
            eventInfo: {
                eventName,
                eventAction: EventAction.View_Change,
            },
            attributes: {
                componentName: `${tabName.split(' ').join('-')}-layer`,
            },
        });
    };
    const handleCompareTrackEvent = (checked) => {
        const eventName = `${baseTrackingEventName} - comparison ${checked ? 'on' : 'off'}`;
        handleTrackEvent({
            eventInfo: {
                eventName,
                eventAction: EventAction.Content,
            },
            attributes: {
                elementName: 'toggle',
            },
        });
    };
    const createTabItems = () => {
        const standardEquipmentTab = {
            label: i18n('compareLayer.header.standardEquipment'),
            content: (config === null || config === void 0 ? void 0 : config.selectedTab) === 'standardEquipment' ? (_jsx(StandardEquipment, { actions: actions })) : (_jsx("div", {})),
            active: (config === null || config === void 0 ? void 0 : config.selectedTab) === 'standardEquipment',
            onClick: (config === null || config === void 0 ? void 0 : config.hideTabs)
                ? () => { }
                : () => {
                    var _a;
                    (_a = actions === null || actions === void 0 ? void 0 : actions.onChangeActiveTab) === null || _a === void 0 ? void 0 : _a.call(actions, 'standardEquipment');
                    handleTabTrackEvent('standard equipment');
                },
        };
        const technicalDataTab = {
            label: i18n('compareLayer.header.technicalData'),
            content: (config === null || config === void 0 ? void 0 : config.selectedTab) === 'technicalData' ? _jsx(TechData, { actions: actions }) : _jsx("div", {}),
            active: (config === null || config === void 0 ? void 0 : config.selectedTab) === 'technicalData',
            onClick: (config === null || config === void 0 ? void 0 : config.hideTabs)
                ? () => { }
                : () => {
                    var _a;
                    (_a = actions === null || actions === void 0 ? void 0 : actions.onChangeActiveTab) === null || _a === void 0 ? void 0 : _a.call(actions, 'technicalData');
                    handleTabTrackEvent('technical data');
                },
            disabled: !techData || !techData.length,
        };
        if (config === null || config === void 0 ? void 0 : config.hideTabs) {
            if (config.selectedTab === 'standardEquipment') {
                return [standardEquipmentTab];
            }
            if (config.selectedTab === 'technicalData') {
                return [technicalDataTab];
            }
        }
        return [standardEquipmentTab, technicalDataTab];
    };
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        const baseCompareVehicle = {
            productInfo: {
                productID: (_a = configuredCar.carline) === null || _a === void 0 ? void 0 : _a.id,
                productName: (_b = configuredCar.carline) === null || _b === void 0 ? void 0 : _b.name,
                manufacturer: 'Audi',
            },
            category: {
                primaryCategory: (_c = configuredCar.carline) === null || _c === void 0 ? void 0 : _c.id,
                subCategory1: (_d = configuredCar.carline) === null || _d === void 0 ? void 0 : _d.id,
                productType: 'compared car',
            },
        };
        const comparedVehicle = [
            Object.assign(Object.assign({}, baseCompareVehicle), { price: {
                    modelPrice: (_f = (_e = selectedEngine === null || selectedEngine === void 0 ? void 0 : selectedEngine.prices) === null || _e === void 0 ? void 0 : _e.price) === null || _f === void 0 ? void 0 : _f.value,
                    currency: (_j = (_h = (_g = selectedEngine === null || selectedEngine === void 0 ? void 0 : selectedEngine.prices) === null || _g === void 0 ? void 0 : _g.price) === null || _h === void 0 ? void 0 : _h.currencyDetails) === null || _j === void 0 ? void 0 : _j.code,
                }, attributes: {
                    engine: selectedEngine === null || selectedEngine === void 0 ? void 0 : selectedEngine.engineName,
                } }),
            ...(secondSelectedEngine
                ? [
                    Object.assign(Object.assign({}, baseCompareVehicle), { price: {
                            modelPrice: (_l = (_k = secondSelectedEngine === null || secondSelectedEngine === void 0 ? void 0 : secondSelectedEngine.prices) === null || _k === void 0 ? void 0 : _k.price) === null || _l === void 0 ? void 0 : _l.value,
                            currency: (_p = (_o = (_m = secondSelectedEngine === null || secondSelectedEngine === void 0 ? void 0 : secondSelectedEngine.prices) === null || _m === void 0 ? void 0 : _m.price) === null || _o === void 0 ? void 0 : _o.currencyDetails) === null || _p === void 0 ? void 0 : _p.code,
                        }, attributes: {
                            engine: secondSelectedEngine === null || secondSelectedEngine === void 0 ? void 0 : secondSelectedEngine.engineName,
                        } }),
                ]
                : []),
        ];
        handleUpdateComponentInfo({
            attributes: {
                products: {
                    comparedVehicle,
                },
            },
        });
    }, [
        selectedEngine,
        secondSelectedEngine,
        handleUpdateComponentInfo,
        (_a = configuredCar.carline) === null || _a === void 0 ? void 0 : _a.id,
        (_b = configuredCar.carline) === null || _b === void 0 ? void 0 : _b.name,
    ]);
    useEffect(() => {
        handleUpdateComponentInfo({
            attributes: {
                comparisonToggleOn: compare ? 'true' : 'false',
            },
        });
    }, [compare, handleUpdateComponentInfo]);
    return (_jsxs(StyledHeader, { hideTabs: config === null || config === void 0 ? void 0 : config.hideTabs, children: [_jsx("div", { className: "toggle-switch-container", children: !(config === null || config === void 0 ? void 0 : config.isDisabled) && (_jsx(ToggleSwitch, { checked: compare, "data-testid": "compare-toggle-switch", id: "compare-toggle-switch", label: i18n('compareLayer.header.compare'), labelPosition: "leading", name: "compare-toggle-switch", onChange: (e) => {
                        const checked = e.target.checked;
                        setCompare(checked);
                        handleCompareTrackEvent(checked);
                    }, value: "compare-toggle-switch" })) }), _jsx(Tabs, { items: createTabItems(), id: "header-tabs", size: "sm", className: "tabs", onKeyNavigate: (newIndex) => {
                    var _a;
                    const tabName = tabIndexToTabName[newIndex];
                    if (tabName) {
                        (_a = actions === null || actions === void 0 ? void 0 : actions.onChangeActiveTab) === null || _a === void 0 ? void 0 : _a.call(actions, tabName);
                        handleTabTrackEvent(tabName);
                    }
                }, scrollButtons: {
                    left: {
                        ariaLabel: 'Scroll left',
                    },
                    right: {
                        ariaLabel: 'Scroll right',
                    },
                } })] }));
};
